import { PackingSlipsOptionInput } from "./packingslips-option-input";

export interface PackingSlipsFilters {
  options: PackingSlipsOptionInput;
  next_page_reference: string;
}

export class PackingSlipsFilters {}
